import { formatMoney } from 'common'

import { parseZoneFormat } from 'common/dateFormatters'

import './styles.less'

const CategoryInformation = ({ monthlyAllowanceValue, type, startDate, endDate, benefitEndDate }) => {
  const data = [
    { title: 'Allowance', value: <div> {formatMoney(monthlyAllowanceValue, true)}</div> },
    { title: 'Frequency', value: <div>{type}</div> },
    { title: 'Start Date', value: <div>{parseZoneFormat(startDate)}</div> },
    {
      title: 'End Date',
      value: (
        <div>
          {new Date(endDate).getFullYear() != new Date(benefitEndDate).getFullYear()
            ? parseZoneFormat(endDate)
            : 'Continuous'}
        </div>
      ),
    },
    // { title: 'Renewal', value: <div>09.23.2022</div> },
    // {
    //   title: 'Roll over',
    //   value: (
    //     <div className="flex flex__center">
    //       <Icon type="fas fa-solid fa-check-circle" className="color-green-6 mr-4 card_perks_allowance-rollover" /> ON
    //     </div>
    //   ),
    // },
  ]
  return (
    <>
      {data.map(({ title, value }) => (
        <>
          <hr className="line_style mb-12" />
          <div className="flex__space_between mb-12">
            <div className="color-gray-7">{title}</div>
            {value}
          </div>
        </>
      ))}
      <hr className="line_style mb-12" />
    </>
  )
}

export default CategoryInformation
